import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExplorePageRoutingModule } from './explore-page-routing.module';
import { ExplorePageComponent } from './explore-page.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxLiteYoutubeModule } from 'ngx-lite-video';
import { NgxStarsModule } from 'ngx-stars';


@NgModule({
  declarations: [ExplorePageComponent],
  imports: [
    ExplorePageRoutingModule,FormsModule, ReactiveFormsModule,

    NgxStarsModule,
    CommonModule,
    NgxLiteYoutubeModule,
    CarouselModule
  ]
})
export class ExplorePageModule { }
